/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { ReduxStateLoadable } from './index';
import { AnyAction } from 'redux';
import type { UtrvHistoryInfoInterface } from '../types/universalTrackerValue';

type State = ReduxStateLoadable<UtrvHistoryInfoInterface, unknown[]> & {
  universalTrackerId?: string,
  universalTrackerValueId?: string,
}

const getDefaultState = (): State => ({
  data: [],
  universalTrackerId: undefined,
  universalTrackerValueId: undefined,
  loaded: false,
  errored: false,
  errorMessage: ''
});

const universalTrackerValueDetails = (
  state = getDefaultState(),
  action: AnyAction,
): State => {
  switch (action.type) {

    case actionTypes.LOADING_UNIVERSALTRACKERVALUE_DETAILS:
      return {
        ...state,
        universalTrackerId: action.universalTrackerId,
        universalTrackerValueId: action.universalTrackerValueId,
        data: [],
        loaded: false,
        errored: false,
        lastUpdated: Date.now()
      }
    case actionTypes.ERROR_UNIVERSALTRACKERVALUE_DETAILS:
      return {
        ...state,
        data: [],
        loaded: false,
        errored: true,
        lastUpdated: Date.now(),
        errorMessage: action.errorMessage
      }
    case actionTypes.LOADED_UNIVERSALTRACKERVALUE_DETAILS:
      return {
        ...state,
        data: action.data,
        loaded: true,
        errored: false,
        lastUpdated: Date.now()
      }
    case actionTypes.UNLOAD_UNIVERSALTRACKERVALUE_DETAILS:
      return {
        ...state,
        data: action.data,
        loaded: false,
        errored: false,
        universalTrackerId: undefined,
        universalTrackerValueId: undefined,
        lastUpdated: Date.now()
      }
    default:
      return state;

  }

}

export default universalTrackerValueDetails;
